export const faqs = [
  {
    q: "What exactly is SELF-LIGATING ORTHODONTICS BLUEPRINT™?",
    a: "It's a digital educational collection focused on self-ligating orthodontic systems, biomechanics, clinical assessment, treatment planning considerations, troubleshooting, and finishing principles. It includes six specialized volumes and five complementary professional resources.",
  },
  {
    q: "Is this a course?",
    a: "No. It's a collection of digital books, visual references, checklists, educational scenarios, and planning worksheets. You can study the material at your own pace.",
  },
  {
    q: "Is this suitable for orthodontists?",
    a: "Yes. The material is designed for orthodontists and dental professionals interested in deepening their understanding of self-ligating orthodontic principles. It may also be useful for postgraduate orthodontic students.",
  },
  {
    q: "Do I need to use a specific brand of self-ligating brackets?",
    a: "No. The educational material addresses principles relevant to active and passive self-ligating systems. It is not presented as a manufacturer-specific certification or official training program.",
  },
  {
    q: "Does it cover active and passive self-ligating systems?",
    a: "Yes. The fundamentals volume discusses both mechanisms, including their characteristics, biomechanical considerations, limitations, and evidence-based comparisons.",
  },
  {
    q: "Does it include archwire selection?",
    a: "Yes. Volume III and Bonus #2 cover archwire properties, biomechanical principles, and considerations relevant to clinical decision-making. The material does not prescribe one universal archwire sequence for every patient.",
  },
  {
    q: "Can I use the resources when reviewing cases?",
    a: "The worksheets and reference materials are designed to support professional education, reflection, and organized case discussion. They do not replace patient-specific diagnosis, clinical judgment, specialist training, or applicable professional standards.",
  },
  {
    q: "Can I access the material outside the United States?",
    a: "Yes. The educational content is intended for an international English-speaking professional audience. Clinical decisions must always follow the standards, regulations, and professional requirements applicable in your country.",
  },
  {
    q: "How will I receive the material?",
    a: "After your purchase, you'll receive digital access through the delivery method specified at checkout. The collection is designed for digital reading and reference.",
  },
  {
    q: "Can I download the volumes?",
    a: "Download availability depends on the digital delivery settings used by the store. The product is intended to be supplied as digital PDF materials.",
  },
  {
    q: "Is this a one-time payment?",
    a: "Yes. The complete collection costs $27 USD, paid once. There are no monthly subscription fees for the collection.",
  },
  {
    q: "Do I receive lifetime access?",
    a: "Yes. Lifetime access is included under the store's published digital-access terms.",
  },
  {
    q: "Is there a refund guarantee?",
    a: "Yes, the offer includes a seven-day satisfaction guarantee. The final refund conditions match the policy published at checkout.",
  },
  {
    q: "Will this system guarantee better orthodontic outcomes?",
    a: "No. Orthodontic outcomes depend on numerous patient-specific and clinical factors. This collection is an educational reference designed to support learning and structured clinical reasoning, not to guarantee treatment outcomes.",
  },
];
